import Modal from "react-modal";
import Icon from "../common/Icon";
import { useEffect, useState } from "react";

const QuizAddModal = ({ open, data, onAdd, onClose }) => {
  const [lecture, setLecture] = useState(null);

  const handleSelect = (e) => {
    setLecture(e.target.value);
  };

  const handleAdd = () => {
    onAdd({ lecture });
  };

  useEffect(() => {
    if (data && "selectedLecture" in data && data.selectedLecture) {
      setLecture(data.selectedLecture);
    } else {
      setLecture(null);
    }
  }, [data]);

  return (
    <>
      {open && (
        <Modal
          ariaHideApp={false}
          className="h-full text-center flex"
          isOpen={open}
          onRequestClose={onClose}
        >
          <div className="card bg-white w-full md:w-5/12 md:shadow-xl m-auto p-4">
            <div className="inline-flex gap-4 items-center mt-2">
              <h3 className="text-sm font-bold w-12 text-end">강의</h3>
              <select
                id="classes"
                name="classes"
                autoComplete="classes-name"
                className="h-12 mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-cyan-500 focus:outline-none focus:ring-cyan-500 sm:text-sm"
                onChange={handleSelect}
                defaultValue={data.selectedLecture}
              >
                {"lectureList" in data &&
                  data.lectureList.map(({ _id: id, title: v }) => (
                    <option key={`option_${v}`} value={id}>
                      {v}
                    </option>
                  ))}
              </select>
            </div>
            <div className="card-actions mt-4 w-full">
              <button
                className="btn btn-primary btn-sm w-full"
                disabled={!lecture}
                onClick={handleAdd}
              >
                <Icon name="plus" size="sm" className="inline-block" />
                추가
              </button>
              <button
                className="btn btn-ghost bg-zinc-300 btn-sm w-full"
                onClick={onClose}
              >
                <Icon name="x" size="sm" className="inline-block" />
                닫기
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default QuizAddModal;
